import styled from 'styled-components';
import { Column } from '@ant-design/plots';

export const ColumnBar = styled(Column).attrs({})``;
